import {Button} from '../../atoms/Button';
import {charcoal} from '../../sass/base/_exports.sass';
import {ArrowIcon} from '../../svg/ArrowIcon';

export const LegalCopy = ({simpleFooter}) => {
  const currentYear = new Date().getFullYear();
  const shouldUseFreestarCMP = evite.features.isEnabled('render_freestar_prebid', false);

  // Scroll to top function
  const handleScrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  return (
    <div className={`footer__legal ${simpleFooter ? 'footer__legal--simple' : ''}`}>
      <ul className="footer__legal-links">
        <li>
          <p className="paragraph4">&copy; {currentYear} Evite. All Rights Reserved.</p>
        </li>
        <li className="footer__legal-link">
          <a className="paragraph4" href="/content/privacy_policy/" data-qa-id="footer_privacy">
            Privacy Policy
          </a>
        </li>
        <li className="footer__legal-link">
          <a
            className="paragraph4"
            href="/content/terms/#trademark_top"
            data-qa-id="trademark_notices"
          >
            Trademark Notices
          </a>
        </li>
        <li className="footer__legal-link">
          <a className="paragraph4" href="/content/terms/" data-qa-id="footer_terms">
            Terms of Service
          </a>
        </li>
        <li className="footer__legal-link">
          <a
            className="paragraph4"
            href="/content/privacy_policy/#addtl_disclosures_CA"
            data-qa-id="california_notice"
          >
            California Privacy Notice
          </a>
        </li>
        <li className="footer__legal-link">
          {/** biome-ignore lint/a11y/useValidAnchor: existing functionality */}
          <a className="paragraph4" data-qa-id="privacy_choices" data-cc="c-settings">
            Your Privacy Choices
          </a>
        </li>
        {shouldUseFreestarCMP && (
          <li className="footer__legal-link">
            {/** biome-ignore lint/a11y/useValidAnchor: Freestar CMP injected through this div EVT-36546 */}
            <a className="paragraph4" id="pmLink">
              Privacy Manager
            </a>
          </li>
        )}
        {simpleFooter ? (
          <li className="footer__legal-link">
            <a className="paragraph4" href="https://support.evite.com/" data-qa-id="footer_help">
              Get Help
            </a>
          </li>
        ) : null}
      </ul>

      {!simpleFooter ? (
        <div className="footer__back-to-top">
          <Button
            variant="transparent"
            className="back-to-top-link"
            onClick={handleScrollToTop}
            data-qa-id="footer-scroll-to-top-button"
          >
            Back to Top
            <ArrowIcon className="back-button__icon" ratio={0.5} color={charcoal} direction="up" />
          </Button>
        </div>
      ) : null}
    </div>
  );
};
